/**
 * Run object has its own internal state and public functions
 * to manipulate that state.
 */
export default function () {
  this.name = null
  this.loadedFromSaved = false
  this.runService = null
  this.variableService = null
  this.scenario = null
  this.currentStep = 0
  this.creditsSpent = 0
  this.inputVariables = []
  this.savedOutput = []
  this.isStepRunning = false
  this.comparisionSlug = null

  const getName = () => {
    return this.name
  }

  const setName = (name) => {
    this.name = name
  }

  const isLoadedFromSaved = () => {
    return this.loadedFromSaved
  }

  const setLoadedFromSaved = (loadedFromSaved) => {
    this.loadedFromSaved = loadedFromSaved
  }

  const getRunService = () => {
    return this.runService
  }

  const setRunService = (runService) => {
    this.runService = runService
  }

  const getVariableService = () => {
    return this.variableService
  }

  const setVariableService = (variableService) => {
    this.variableService = variableService
  }

  const getScenario = () => {
    return this.scenario
  }

  const setScenario = (scenario) => {
    this.scenario = scenario
  }

  const getCurrentStep = () => {
    return this.currentStep
  }

  const setCurrentStep = (currentStep) => {
    this.currentStep = currentStep
  }

  const getCreditsSpent = () => {
    return this.creditsSpent
  }

  const setCreditsSpent = (creditsSpent) => {
    this.creditsSpent = creditsSpent
  }

  const getInputVariables = () => {
    return this.inputVariables
  }

  const setInputVariables = (inputVariables) => {
    this.inputVariables = inputVariables
  }

  const getSavedOutput = () => {
    return this.savedOutput
  }

  const setSavedOutput = (savedOutput) => {
    this.savedOutput = savedOutput
  }

  const isRunning = () => {
    return this.isStepRunning
  }

  const setRunning = (isRunning) => {
    this.isStepRunning = !!isRunning
  }

  const setComparisionSlug = (comparisionSlug) => {
    this.comparisionSlug = comparisionSlug
  }

  const getComparisionSlug = () => {
    return this.comparisionSlug
  }

  const addDataFromJson = (json) => {
    setName(json.name)
    setLoadedFromSaved(true)
    setScenario(json.scenario)
    setCurrentStep(json.currentStep)
    setInputVariables(json.inputVariables)
    setSavedOutput(json.savedOutput)
  }

  const getAsJson = () => {
    return {
      name: this.name,
      scenario: this.scenario,
      currentStep: this.currentStep,
      inputVariables: this.inputVariables,
      savedOutput: this.savedOutput,
    }
  }

  return {
    getName,
    setName,
    isLoadedFromSaved,
    setLoadedFromSaved,
    getRunService,
    setRunService,
    getVariableService,
    setVariableService,
    getScenario,
    setScenario,
    getCurrentStep,
    setCurrentStep,
    getCreditsSpent,
    setCreditsSpent,
    getInputVariables,
    setInputVariables,
    getSavedOutput,
    setSavedOutput,
    addDataFromJson,
    getAsJson,
    isRunning,
    setRunning,
    getComparisionSlug,
    setComparisionSlug,
  }
}
